export const dateOptions = [
  { label: "Custom", value: "custom" },
  { label: "This Week", value: "thisWeek" },
  { label: "This Month", value: "thisMonth" },
  { label: "Last 3 Months", value: "last3Months" },
  { label: "Last 6 Months", value: "last6Months" },
  { label: "Last 12 Months", value: "last12Months" },
  { label: "Last Calendar Year", value: "lastCalendarYear" },
];
